module.exports = __webpack_public_path__ + "static/media/complete-button-animation.c2753592.gif";